var _style, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 318.2",
    style: {
      enableBackground: "new 0 0 512 318.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#FFA000;}\n\t.st2{fill:#D32F2F;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.4,
    className: "st0",
    width: 512,
    height: 318.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.8,159.1c0,51.3-41.6,92.9-92.9,92.9s-92.8-41.6-92.8-92.9s41.6-92.9,92.8-92.9S410.8,107.8,410.8,159.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287,159.1c0,51.3-41.6,92.9-92.9,92.9s-92.8-41.6-92.8-92.9s41.6-92.9,92.8-92.9S287,107.8,287,159.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.3998be4a65cf73a5848a1dcf7b99b8c9.svg";
export { ForwardRef as ReactComponent };